/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* ---------------------------------------------------------------------------
   FIX 1 (2026-09-04): "Cannot read properties of undefined (reading 'reduce')"
   appearing above the Add to Cart button.

   Cause: Shopify's /recommendations/products.json endpoint sometimes answers
   with an error body -- e.g. 404 {"status":404,"message":"Not Found",...} --
   instead of the expected {"products":[...]}. cart-store.js stores that
   response as-is, so recommendations.items[id].products becomes undefined.
   cart-recommendations.js then calls .reduce() on it and throws a TypeError.
   Because that runs inside Cart.add(), product-form.js catches the TypeError
   and prints its raw message over the Add to Cart button -- even though the
   item was already added to the cart successfully.

   Symptom: the first add-to-cart on a page works; every add after it shows the
   red error, because cart recommendations only switch on after the first add.

   This normalises any non-conforming recommendations response to an empty
   product list, which the theme already handles correctly. Nothing else is
   changed, and no other network request is touched.
--------------------------------------------------------------------------- */
(function () {
  if (typeof window.fetch !== 'function' || window.__ppRecFixInstalled) return;
  window.__ppRecFixInstalled = true;

  var originalFetch = window.fetch;

  var emptyRecommendations = function () {
    return new Response('{"products":[],"results_count":0}', {
      status: 200,
      headers: { 'Content-Type': 'application/json' }
    });
  };

  window.fetch = function () {
    var input = arguments[0];
    var url = String((input && input.url) || input || '');
    var result = originalFetch.apply(this, arguments);

    if (url.indexOf('/recommendations/products.json') === -1) return result;

    return result.then(function (response) {
      return response.clone().json().then(function (body) {
        return (body && Array.isArray(body.products)) ? response : emptyRecommendations();
      }, emptyRecommendations);
    }, emptyRecommendations);
  };
})();


/* ---------------------------------------------------------------------------
   FIX 2 (2026-09-04): never show raw JavaScript errors to shoppers.

   The theme's product-form.js wraps the whole add-to-cart sequence in one
   try/catch and prints catch(e) => e.message directly above the Add to Cart
   button. That is correct for genuine Shopify messages ("All 3 in your cart",
   "sold out"), but it means ANY JavaScript fault anywhere in that sequence --
   in the theme, or in any installed app that hooks the cart -- becomes
   customer-facing text like "Cannot read properties of undefined".

   This watches for those error boxes and, when the text is a raw JS error:
     - hides it instantly, so nothing flashes on screen
     - logs the real error to the browser console for debugging
     - checks whether the item actually reached the cart
         -> it did:     removes the message entirely (the add worked)
         -> it did not: shows a plain-English message instead

   Genuine Shopify messages are left completely untouched.
--------------------------------------------------------------------------- */
(function () {
  if (window.__ppErrorGuardInstalled) return;
  window.__ppErrorGuardInstalled = true;

  // Signatures of a JavaScript fault, as opposed to a real merchandising message.
  var RAW_JS_ERROR = /\b(TypeError|ReferenceError|RangeError|SyntaxError|InternalError|EvalError)\b|cannot read propert|is not a function|is not defined|is not iterable|is not a constructor|undefined is not|null is not|of undefined|of null/i;

  var FRIENDLY = "Sorry, we couldn't add that just now. Please refresh the page and try again.";

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  function inspect(node) {
    if (!node || node.nodeType !== 1 || !node.closest) return;

    var form = node.closest('product-form');
    if (!form) return;

    var text = (node.textContent || '').trim();
    if (!text || !RAW_JS_ERROR.test(text)) return; // a real Shopify message - leave it alone

    // Hide first so the shopper never sees it, decide what to do second.
    node.style.display = 'none';
    if (window.console && console.error) {
      console.error('[Prime Party] Suppressed a raw JS error on Add to Cart:', text);
    }

    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput && idInput.value;

    var showFriendly = function () {
      node.textContent = FRIENDLY;
      node.style.display = '';
    };

    if (!variantId) { showFriendly(); return; }

    fetch(cartUrl(), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var landed = (cart && cart.items || []).some(function (item) {
          return String(item.variant_id) === String(variantId);
        });
        if (landed) {
          node.remove(); // the add actually succeeded - say nothing
        } else {
          showFriendly();
        }
      })
      .catch(showFriendly);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var added = mutations[m].addedNodes;
      for (var i = 0; i < added.length; i++) {
        var node = added[i];
        if (!node || node.nodeType !== 1) continue;

        if (node.classList && node.classList.contains('errors')) {
          inspect(node);
        } else if (node.querySelectorAll) {
          var nested = node.querySelectorAll('.errors');
          for (var j = 0; j < nested.length; j++) inspect(nested[j]);
        }
      }
    }
  });

  var start = function () {
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();

// Insert any custom theme js here...
